import { useQuery } from "@tanstack/vue-query"
import { explorerApi } from "~/api/client"
import type { NexonLwTotalSupplyBreakdownInfo } from "~/api/repository/models/NexonLwTotalSupplyBreakdownInfo"
import { setCommaWithDigits } from "~/utils/numberFormat"

export const getLivewatchTotalSupplyBreakdown = () => {
    return useQuery({
        queryKey: ['livewatchTotalSupplyBreakdown'],
        queryFn: () => explorerApi.lwController.getTotalSupplyBreakdown({
            requestBody: {
                assetSymbol: 'NEXON',
            }
        }).then(res => livewatchTotalSupplyBreakdownDto(res))
    })
}

export type LivewatchTotalSupplyBreakdown = {
    symbol: string; 
    indicators: LivewatchTotalSupplyBreakdownInfo;
}

export type LivewatchTotalSupplyBreakdownInfo = {
    totalIssued: number;
    totalSupply: number;
    totalBurned: number;
    nonCirculatingSupply: number;
    circulatingSupply: number;
}

const livewatchTotalSupplyBreakdownDto = (totalSupplyBreakdown: NexonLwTotalSupplyBreakdownInfo): LivewatchTotalSupplyBreakdown => {
    return {
        symbol: totalSupplyBreakdown.SB,
        indicators: {
            totalIssued: Number(totalSupplyBreakdown.IND.TI),
            totalSupply: Number(totalSupplyBreakdown.IND.TS),
            totalBurned: Number(totalSupplyBreakdown.IND.TB),
            nonCirculatingSupply: Number(totalSupplyBreakdown.IND.NCS),
            circulatingSupply: Number(totalSupplyBreakdown.IND.CS),
        }
    }
}